export default __webpack_public_path__ + "static/media/testamonialAvatar2.3bef243a.jpg";